module.exports = __webpack_public_path__ + "../resources/images/drophint_2x_s-3eeeb8ce6c80ea9b653bc063000c1411.png";